import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../apiClient';

export interface FormQuestionOption {
    _id: string;
    value: string;
    questionId: string;
    order: number;
    mark?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormQuestionOptionsResponse {
    message: string;
    data: FormQuestionOption[];
}

export interface FormQuestionOptionResponse {
    message: string;
    data: FormQuestionOption;
}

export interface CreateFormQuestionOptionBody {
    questionId: string;
    value: string;
    order?: number;
    mark?: number;
}

export interface UpdateFormQuestionOptionBody {
    value?: string;
    order?: number;
    mark?: number;
}

export interface MoveFormQuestionOptionBody {
    newOrder: number;
}

export const createFormQuestionOption = async (data: CreateFormQuestionOptionBody): Promise<FormQuestionOptionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionOptionResponse> = await apiClient.post('/form-options', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DUPLICATE
export const duplicateFormQuestionOption = async (optionId: string): Promise<FormQuestionOptionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionOptionResponse> = await apiClient.post(`/form-options/${optionId}/duplicate`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// UPDATE
export const updateFormQuestionOption = async (optionId: string, data: UpdateFormQuestionOptionBody): Promise<FormQuestionOptionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionOptionResponse> = await apiClient.patch(`/form-options/${optionId}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// MOVE
export const moveFormQuestionOption = async (optionId: string, data: MoveFormQuestionOptionBody): Promise<FormQuestionOptionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionOptionResponse> = await apiClient.patch(`/form-options/${optionId}/move`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DELETE
export const deleteFormQuestionOption = async (optionId: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-options/${optionId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
